import { motion } from "framer-motion";

export function ButtonMotion({
  disabled = false,
  children,
}) {
  if (disabled) return children;

  return (
    <motion.section
      whileHover={{
        transition: { duration: 0.3 },
      }}
      whileTap={{ scale: 0.9 }}
    >
      {children}
    </motion.section>
  );
}
